﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customEventThemeColorList from './tpl/customEventThemeColorList.html';
import View_CustomEvenThemeColorListItem from './customEventThemeColorListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customEventThemeColorList',
    childViewContainer: '#customEventThemeColorList',
    childView: View_CustomEvenThemeColorListItem,
    getTemplate: function () {
        return tpl_customEventThemeColorList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        options.localSetting = this.options.localSetting;
        options.mainCollection = this.options.mainCollection;
        var view = new ChildViewClass(options);
        return view;
    }
});
